import AlarmsPrimary from '@sma/components/device/alarms';

export default AlarmsPrimary;
